// components/Orders/OrderStepTracker.jsx
// ─────────────────────────────────────────────────────────────────────────────
// The four rungs of a delivery, drawn once.
//
// ASKED FOR 27 Sep 2026: "you forgot to include the steps or order journey,
// this way a user gets to know what steps to do next." The rebuilt order screen
// carried OrderNextStep — which says what to do NEXT — but not the ladder that
// shows where in the journey the order actually is. One without the other is
// an instruction with no map: you are told to dispatch, with nothing saying
// how much of the delivery is already behind you.
//
// Stage, label and completion all come from utilities/orderDeliverySteps.js,
// which is the single place that knows all TEN delivery_status members and
// which of the four rungs each one sits on. Two restaurant screens draw this
// from their own local `statusSteps` array and their own `getStepClass`; this
// component is the shared version for everything else, and those two should
// adopt it next time they are opened.
//
// A CANCELLED order is not a stage-0 order. It leaves the ladder entirely,
// rather than showing three grey dots that imply it is still waiting to be
// picked up. It does not say so here: both screens that draw this ladder draw
// OrderNextStep right under it, and that banner already carries the title,
// the explanation and the recorded reason. Until 13 Oct 2026 this component
// drew its own red "Order cancelled" strip as well, so a cancelled order
// opened to the same sentence twice, one above the other.
// ─────────────────────────────────────────────────────────────────────────────

import React from "react";
import {
  DELIVERY_STAGES,
  getDeliveryStep,
  AUDIENCE,
} from "../../utilities/orderDeliverySteps";
import StepLadder from "./StepLadder";

const OrderStepTracker = ({ order, audience = AUDIENCE.ADMIN, style }) => {
  if (!order) return null;

  const step = getDeliveryStep(order, { audience });

  if (step.isCancelled) return null;

  const steps = DELIVERY_STAGES.map((stage, index) => {
    const done = index < step.stage || step.isTerminal;
    const active = index === step.stage && !step.isTerminal;
    return { key: stage.key, label: stage.label, state: done ? "done" : active ? "active" : "todo" };
  });

  return <StepLadder steps={steps} label="Delivery progress" style={style} />;
};

export default OrderStepTracker;
